import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint.tsx';
import { PageIndices } from '../../../common/i-doc/i-doc.registry.ts';
import { LegacyColumn, LegacyListTable, yesNo } from '@components/pm/legacy/LegacyListTable.tsx';
import { LegacyExpert, pmLegacyService } from '@services/pm-legacy.service.ts';

const COLUMNS: LegacyColumn<LegacyExpert>[] = [
  { label: 'ID', render: (r) => r.id },
  {
    label: 'ПІБ',
    render: (r) => (
      <>
        <Typography variant="body2" fontWeight={500}>{r.fullName || '—'}</Typography>
        {r.isDeleted && <Typography variant="caption" color="error">видалений</Typography>}
      </>
    ),
  },
  { label: 'Організація', render: (r) => (r.orgId ? `${r.orgName ?? '—'} (#${r.orgId})` : null) },
  { label: 'Роль', render: (r) => r.role },
  { label: 'Спеціалізація', render: (r) => r.specialization },
  { label: 'Логін', render: (r) => r.login },
  { label: 'Стать', render: (r) => r.sex },
  { label: 'Реєстрація', render: (r) => r.registeredAt, nowrap: true },
  { label: 'Підписка', render: (r) => yesNo(r.isSubscribed), align: 'center' },
  { label: 'Telegram', render: (r) => yesNo(r.isTelegramSubscribed), align: 'center' },
];

const PmLegacyExpertsPageContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  return (
    <Box data-i-doc={PageIndices.PM_LEGACY_EXPERTS}>
      <PageHint iDoc={PageIndices.PM_LEGACY_EXPERTS} />
      <LegacyListTable
        storageKey="pm-legacy-experts"
        searchLabel="Пошук: ID, ПІБ, логін, спеціалізація"
        columns={COLUMNS}
        fetch={pmLegacyService.getExperts}
        withOrgFilter
        initialOrgId={searchParams.get('orgId') ?? ''}
      />
    </Box>
  );
};

export const PmLegacyExpertsPage: React.FC = () => (
  <DashboardLayout>
    <PmLegacyExpertsPageContent />
  </DashboardLayout>
);
